 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_9780813121307_COVER from '@/components/html/00_9780813121307_Cover'
 import HTML01_9780813121307_HALFTITLE from '@/components/html/01_9780813121307_Halftitle'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML02_9780813121307_TITLE from '@/components/html/02_9780813121307_Title'
 import HTML03_9780813121307_COPYRIGHT from '@/components/html/03_9780813121307_Copyright'
 import HTML04_9780813121307_DEDICATION from '@/components/html/04_9780813121307_Dedication'
 import HTML05_9780813121307_CONTENTS from '@/components/html/05_9780813121307_Contents'
 import HTML06_9780813121307_PREFACE from '@/components/html/06_9780813121307_Preface'
 import HTML07_9780813121307_INTRO from '@/components/html/07_9780813121307_Intro'
 import HTML08_9780813121307_CHAPTER01 from '@/components/html/08_9780813121307_Chapter01'
 import HTML09_9780813121307_CHAPTER02 from '@/components/html/09_9780813121307_Chapter02'
 import HTML10_9780813121307_CHAPTER03 from '@/components/html/10_9780813121307_Chapter03'
 import HTML11_9780813121307_CHAPTER04 from '@/components/html/11_9780813121307_Chapter04'
 import HTML12_9780813121307_CHAPTER05 from '@/components/html/12_9780813121307_Chapter05'
 import HTML13_9780813121307_CHAPTER06 from '@/components/html/13_9780813121307_Chapter06'
 import HTML14_9780813121307_CHAPTER07 from '@/components/html/14_9780813121307_Chapter07'
 import HTML15_9780813121307_CHAPTER08 from '@/components/html/15_9780813121307_Chapter08'
 import HTML16_9780813121307_CHAPTER09 from '@/components/html/16_9780813121307_Chapter09'
 import HTML17_9780813121307_CHAPTER10 from '@/components/html/17_9780813121307_Chapter10'
 import HTML18_9780813121307_CHAPTER11 from '@/components/html/18_9780813121307_Chapter11'
 import HTML19_9780813121307_CHAPTER12 from '@/components/html/19_9780813121307_Chapter12'
 import HTML20_9780813121307_CHAPTER13 from '@/components/html/20_9780813121307_Chapter13'
 import HTML21_9780813121307_CHAPTER14 from '@/components/html/21_9780813121307_Chapter14'
 import HTML22_9780813121307_CHAPTER15 from '@/components/html/22_9780813121307_Chapter15'
 import HTML23_9780813121307_CHAPTER16 from '@/components/html/23_9780813121307_Chapter16'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML24_9780813121307_REFERENCES from '@/components/html/24_9780813121307_References'
 import HTML25_9780813121307_ABOUT_THE_AUTHOR from '@/components/html/25_9780813121307_About_The_Author'
 import HTML26_9780813121307_INDEX from '@/components/html/26_9780813121307_Index'
 import HTML27_9780813121307_INDEX1 from '@/components/html/27_9780813121307_Index1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_9780813121307_Contents",
 			"name" : "html/05_9780813121307_Contents",
 			"component" : HTML05_9780813121307_CONTENTS
 		},
 		{
 			"path" : "/html/06_9780813121307_Preface",
 			"name" : "html/06_9780813121307_Preface",
 			"component" : HTML06_9780813121307_PREFACE
 		},
 		{
 			"path" : "/html/07_9780813121307_Intro",
 			"name" : "html/07_9780813121307_Intro",
 			"component" : HTML07_9780813121307_INTRO
 		},
 		{
 			"path" : "/html/08_9780813121307_Chapter01",
 			"name" : "html/08_9780813121307_Chapter01",
 			"component" : HTML08_9780813121307_CHAPTER01
 		},
 		{
 			"path" : "/html/09_9780813121307_Chapter02",
 			"name" : "html/09_9780813121307_Chapter02",
 			"component" : HTML09_9780813121307_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js